import { graphql } from 'gatsby';
import React from 'react';

import { ArrowLink } from '../components/Common/Links';
import HalfAndHalfHeader from '../components/Heros/HalfAndHalfHeader';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import { ResourceCards } from '../components/PageSections/AdditionalResources';
import PageSection from '../components/PageSections/PageSection';
import AgentAiHint from '../components/ScavengerHunt/Hints/AgentAiHint';
//import { sortByPublishDate } from '../tools/mappers';
import * as styles from './resourcesHomepage.module.scss';

const ResourceSection = ({ title, url, resources }) => {
  return (
    <PageSection slim data-analytics-section={`resources-homepage-${title.toLowerCase().replace(' ', '-')}`}>
      <div
        className={styles.heading}
        data-analytics-component={`resources-homepage-${title.toLowerCase().replace(' ', '-')}`}
      >
        <h3>{title}</h3>
        <ArrowLink label={'View All'} url={url} />

        {title.toLowerCase().includes('ai') && <AgentAiHint />}
      </div>
      <div
        className={styles.cards}
        data-analytics-section={`resources-homepage-list-${title.toLowerCase().replace(' ', '-')}`}
      >
        <ResourceCards useContentType={true} content={resources} showImage={true} flipImage={false} />
      </div>
    </PageSection>
  );
};

const ResourcesHomepage = (props) => {
  const { page } = props.data;
  //console.log(page);
  //TODO: Retaining for possibility of adding "Load More"
  // Load more data
  // const videoIds = page.videoLibrary?.map((v) => v.contentful_id);
  // const videoLibraryPosts = [
  //   ...(blogPosts || []),
  //   ...(caseStudies || []),
  //   ...(resources || []),
  //   ...(walledResources || []),
  // ];
  // const filtered = videoLibraryPosts
  //   .filter((post) => videoIds.indexOf(post.contentful_id) === -1)
  //   .sort(sortByPublishDate);
  return (
    <Layout pageMeta={page.pageMetaData} className={styles.page} isDach={props.pageContext.isDach}>
      <HalfAndHalfHeader
        data-analytics-section={'resources-homepage-header'}
        featured={true}
        verticalBleed={false}
        fields={{
          heroImage: page.headerImage,
          backgroundImage: page.headerBackgroundImage,
          heading: page.heading,
          headingSuper: page.headerEyebrow,
          lede: page.headerLede,
          ctas: [
            {
              url: page.ctaUrl,
              linkText: page.ctaLabel,
            },
          ],
        }}
      />
      <ResourceSection
        resources={page.videoLibrary}
        url={'/resources/solution/video-library/'}
        title={'Video Library'}
      />
      <ResourceSection resources={page.useCases} url={'/resources/solution/use-cases/'} title={'Use Cases'} />

      <ResourceSection
        resources={page.aiBehavioralData}
        url={'/resources/solution/ai-behavioral-data/'}
        title={'AI & Behavioral Data'}
      />

      <ResourceSection
        resources={page.dataExcellence}
        url={'/resources/solution/data-excellence/'}
        title={'Data Excellence'}
      />
      <ResourceSection
        resources={page.actionableAnalytics}
        url={'/resources/solution/actionable-analytics/'}
        title={'Actionable Analytics'}
      />

      <ResourceSection
        resources={page.securityCompliance}
        url={'/resources/solution/security-compliance/'}
        title={'Security & Compliance'}
      />
    </Layout>
  );
};

export const Head = ({ data: { page }, location }) => <MarketingSeo meta={page.pageMeta} slug={location.pathname} />;

export default ResourcesHomepage;

export const pageQuery = graphql`
  query GetResourcesHomepageRebrand($id: String!) {
    page: contentfulPageResourcesHomepage(id: { eq: $id }) {
      heading
      headerLede
      headerBackgroundImage {
        ...ContentfulImage
      }
      headerImage {
        ...ContentfulImage
      }
      ctaLabel
      ctaUrl
      headerEyebrow
      pageMetaData {
        ...PageMetaData
      }
      videoLibrary {
        ...ResourceCards
      }
      dataExcellence {
        ...ResourceCards
      }
      actionableAnalytics {
        ...ResourceCards
      }
      useCases {
        ...ResourceCards
      }
      aiBehavioralData {
        ...ResourceCards
      }
      securityCompliance {
        ...ResourceCards
      }
      featuredResources {
        ...ResourceCards
      }
    }
    # contentful_id : Video Content Type
    #    videoLibrary: contentfulTaxContentType(contentful_id: { eq: "1UYn1LCWqDhxqB2LsrvSFY" }) {
    #      ...GroupedArticlesTaxContent
    #    }
    #    solutions: allContentfulTaxSolution(filter: { node_locale: { eq: "en-US" } }) {
    #      nodes {
    #        slug
    #        title
    #        ...GroupedSolutionArticles
    #      }
    #    }
  }
`;
